import { TextColor, TextSpan } from '../../../Atoms/Text';
import { FeatureResponseState } from '../../../../types/advise';
import { AWAITING_LABEL, AWAITING_MARK, STATE_LABELS, STATE_MARKS } from './SupplierFeatureInput.calc';

const STATE_COLORS: Record<FeatureResponseState, TextColor> = {
  supported: 'green',
  partial: 'orange',
  not_supported: 'red'
};

/** A supplier's answer as the legend shows it; no state yet reads "Awaiting response". */
export const FeatureStateLabel = ({ state }: { state: FeatureResponseState | null }) => {
  return (
    <TextSpan
      size="sm"
      weight={state ? 'medium' : 'normal'}
      color={state ? STATE_COLORS[state] : 'grey6'}>
      <span aria-hidden="true">{state ? STATE_MARKS[state] : AWAITING_MARK}</span>{' '}
      {state ? STATE_LABELS[state] : AWAITING_LABEL}
    </TextSpan>
  );
};
